import type { PotSummaryDto } from '@billda/api';
import type { OwnerType, PotSummary } from '../types/pot.types';

// The generated contract types these as plain strings, because the backend
// builds them as strings rather than enums. Narrow them here, at the DTO
// boundary, instead of asserting a shape the API does not guarantee.
const DEADLINE_TYPES = ['BookIn', 'Verify', 'Submit'] as const;

const toOwnerType = (value: string): OwnerType =>
  value === 'Gang' ? 'Gang' : 'Solo';

const toDeadlineType = (
  value: string | null | undefined
): (typeof DEADLINE_TYPES)[number] | null =>
  DEADLINE_TYPES.find(type => type === value) ?? null;

interface PeriodInfo {
  year: number;
  weekNumber: number;
  start: string;
  end: string;
}

/**
 * Convert API DTO to PotSummary type for table display
 */
export function convertToTablePot(
  dto: PotSummaryDto,
  period: PeriodInfo
): PotSummary {
  return {
    id: dto.id,
    owner: {
      type: toOwnerType(dto.ownerType),
      name: dto.ownerName,
    },
    period: {
      year: period.year,
      weekNumber: period.weekNumber,
      start: period.start,
      end: period.end,
    },
    status: dto.status as PotSummary['status'],
    netAmount: dto.netAmount,
    nextDeadline: {
      date: dto.nextDeadline,
      type: toDeadlineType(dto.nextDeadlineType),
    },
    isScheduledForAutoSubmit: dto.isScheduledForAutoSubmit,
    isPrimary: dto.isPrimary,
    wasLate: dto.wasLate,
    submitDeadlineExtendedUntil: dto.submitDeadlineExtendedUntil ?? null,
  };
}
